<script>
import compoment from '@/components/draggable/CustomComponents/Select/DSelectEditor'
export default {
  name: 'DColumnMTemplateEditor',
  extends: compoment
}
</script>
